import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from './api';

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [site, setSite]       = useState(null);
  const [theme, setTheme]     = useState(() => localStorage.getItem('nsc-theme') || 'light');
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(() => {
    return api.me().then(res => {
      if (res?.ok) {
        setUser({ username: res.data.username, role: res.data.role, permissions: res.data.permissions, totp_enabled: res.data.totp_enabled, pin_hash: res.data.pin_hash });
        setSite(res.data.site);
        // Apply configured accent color to CSS vars
        const colors = res.data.site?.colors;
        if (colors?.accent) {
          document.documentElement.style.setProperty('--accent', colors.accent);
          document.documentElement.style.setProperty('--accent-hover', colors.accent_hover || colors.accent);
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.style.colorScheme = theme;
    localStorage.setItem('nsc-theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return (
    <Ctx.Provider value={{ user, site, theme, toggleTheme, loading, refresh: loadMe }}>
      {children}
    </Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
